import { AmbulatoryDoctorDocument } from 'common/enum/ambulatory-doctor-document'
import { DocumentFile } from 'main/factories/pages/doctor/ambulatory-authorization/ambulatory-authorization-dashboard-factory'

// export const documentList: DocumentFile[] = [
//   {
//     type: AmbulatoryDoctorDocument.IDENTITY_CARD,
//     label: AmbulatoryDoctorDocumentLocation.IDENTITY_CARD,
//     required: false,
//     maxFileSizeInMB: 9
//     // maxFiles: 10,
//     // minFiles: 0,
//     // extensionsAllowed: ['jpg', 'jpeg', 'pdf'],
//     // acceptFiles: 'image/jpeg, application/pdf'
//   },
//   {
//     type: AmbulatoryDoctorDocument.HEALTH_CARD,
//     label: AmbulatoryDoctorDocumentLocation.HEALTH_CARD,
//     required: false,
//     maxFileSizeInMB: 9
//     // maxFiles: 10,
//     // minFiles: 0,
//     // extensionsAllowed: ['jpg', 'jpeg', 'pdf'],
//     // acceptFiles: 'image/jpeg, application/pdf'
//   },
//   {
//     type: AmbulatoryDoctorDocument.MEDICAL_ORDER,
//     label: AmbulatoryDoctorDocumentLocation.MEDICAL_ORDER,
//     required: true,
//     maxFileSizeInMB: 9
//     // maxFiles: 10,
//     // minFiles: 0,
//     // extensionsAllowed: ['jpg', 'jpeg', 'pdf'],
//     // acceptFiles: 'image/jpeg, application/pdf'
//   },
//   {
//     type: AmbulatoryDoctorDocument.LABORATORY_EXAMS,
//     label: AmbulatoryDoctorDocumentLocation.LABORATORY_EXAMS,
//     required: false,
//     maxFileSizeInMB: 9
//     // maxFiles: 10,
//     // minFiles: 0,
//     // extensionsAllowed: ['jpg', 'jpeg', 'pdf'],
//     // acceptFiles: 'image/jpeg, application/pdf'
//   },
//   {
//     type: AmbulatoryDoctorDocument.EXAM_REPORT,
//     label: AmbulatoryDoctorDocumentLocation.EXAM_REPORT,
//     required: false,
//     maxFileSizeInMB: 9
//     // maxFiles: 10,
//     // minFiles: 0,
//     // extensionsAllowed: ['jpg', 'jpeg', 'pdf'],
//     // acceptFiles: 'image/jpeg, application/pdf'
//   },
//   {
//     type: AmbulatoryDoctorDocument.OTHERS,
//     label: AmbulatoryDoctorDocumentLocation.OTHERS,
//     required: false,
//     maxFileSizeInMB: 9
//     // maxFiles: 10,
//     // minFiles: 0,
//     // extensionsAllowed: ['jpg', 'jpeg', 'pdf'],
//     // acceptFiles: 'image/jpeg, application/pdf'
//   }
// ]

export const documentList: DocumentFile[] = [
  {
    type: AmbulatoryDoctorDocument['Carteira de identidade'],
    label: AmbulatoryDoctorDocument['Carteira de identidade'],
    required: false,
    maxFileSizeInMB: 9
    // maxFiles: 10,
    // minFiles: 0,
    // extensionsAllowed: ['jpg', 'jpeg', 'pdf'],
    // acceptFiles: 'image/jpeg, application/pdf'
  },
  {
    type: AmbulatoryDoctorDocument['Carteira do convênio'],
    label: AmbulatoryDoctorDocument['Carteira do convênio'],
    required: false,
    maxFileSizeInMB: 9
    // maxFiles: 10,
    // minFiles: 0,
    // extensionsAllowed: ['jpg', 'jpeg', 'pdf'],
    // acceptFiles: 'image/jpeg, application/pdf'
  },
  {
    type: AmbulatoryDoctorDocument['Pedido médico'],
    label: AmbulatoryDoctorDocument['Pedido médico'],
    required: true,
    maxFileSizeInMB: 9
    // maxFiles: 10,
    // minFiles: 0,
    // extensionsAllowed: ['jpg', 'jpeg', 'pdf'],
    // acceptFiles: 'image/jpeg, application/pdf'
  },
  // {
  //   type: AmbulatoryDoctorDocument['Exames laboratoriais'],
  //   label: AmbulatoryDoctorDocument['Exames laboratoriais'],
  //   required: false,
  //   maxFileSizeInMB: 9
  //   // maxFiles: 10,
  //   // minFiles: 0,
  //   // extensionsAllowed: ['jpg', 'jpeg', 'pdf'],
  //   // acceptFiles: 'image/jpeg, application/pdf'
  // },
  {
    type: AmbulatoryDoctorDocument['Laudo dos exames'],
    label: AmbulatoryDoctorDocument['Laudo dos exames'],
    required: false,
    maxFileSizeInMB: 9
    // maxFiles: 10,
    // minFiles: 0,
    // extensionsAllowed: ['jpg', 'jpeg', 'pdf'],
    // acceptFiles: 'image/jpeg, application/pdf'
  },
  {
    type: AmbulatoryDoctorDocument['Outros'],
    label: AmbulatoryDoctorDocument['Outros'],
    required: false,
    maxFileSizeInMB: 9
    // maxFiles: 10,
    // minFiles: 0,
    // extensionsAllowed: ['jpg', 'jpeg', 'pdf'],
    // acceptFiles: 'image/jpeg, application/pdf'
  }
]
